var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("v-page-header", { attrs: { title: _vm.getPageTile } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLoadingError,
                expression: "hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.loadingError) +
                    "\n                "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLoadingError,
                expression: "!hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("div", { staticClass: "grid-x" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell medium-9 medium-offset-1 large-11 large-offset-0",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrapper" },
                      [
                        _c("v-action-buttons", {
                          attrs: {
                            items: _vm.getActionButtons,
                            isDisabled: _vm.locationFormDisabled,
                          },
                          on: { actionClicked: _vm.onClickAction },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "error",
                            id: "form-error",
                            message: _vm.locationObjectError,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "success",
                            id: "form-success",
                            message: _vm.locationObjectSuccess,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "default",
                            id: "form-activate",
                            message: _vm.locationObjectActivate,
                            autoCloseTimeout: 0,
                            showActionButtons: true,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "box" },
                          [
                            _c("v-navigation"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group form-group--required",
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("customers.location_number"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-control form-control--static",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.locationObject.location_number
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("customers.project_number"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.locationObject.project_number
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "form-field-project-number",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("customers.project_number")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.$v.locationObject.project_number,
                                        expression:
                                          "$v.locationObject.project_number",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "form-field-project-number",
                                      name: "project_number",
                                      placeholder: "0123456789",
                                    },
                                    domProps: {
                                      value:
                                        _vm.$v.locationObject.project_number,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.$v.locationObject,
                                          "project_number",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("customers.company_name"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.locationObject.company_name
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.locationObject.company_name
                                          .$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "form-field-company-name",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("customers.company_name")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.$v.locationObject.company_name
                                              .$model,
                                          expression:
                                            "$v.locationObject.company_name.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "form-field-company-name",
                                        name: "company_name",
                                        placeholder: "Musterfirma",
                                      },
                                      domProps: {
                                        value:
                                          _vm.$v.locationObject.company_name
                                            .$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.locationObject.company_name,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("form.phone"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.locationObject.phone) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.locationObject.phone.$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "form-field-phone" } },
                                      [_vm._v(_vm._s(_vm.$t("form.phone")))]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.$v.locationObject.phone.$model,
                                          expression:
                                            "$v.locationObject.phone.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "tel",
                                        id: "form-field-phone",
                                        name: "phone",
                                        placeholder: _vm.$t("form.phone.plc"),
                                      },
                                      domProps: {
                                        value:
                                          _vm.$v.locationObject.phone.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.locationObject.phone,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("form.address1"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.locationObject.address1) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.locationObject.address1.$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "form-field-adress1" } },
                                      [_vm._v(_vm._s(_vm.$t("form.address1")))]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.$v.locationObject.address1
                                              .$model,
                                          expression:
                                            "$v.locationObject.address1.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "form-field-adress1",
                                        name: "address1",
                                        placeholder:
                                          _vm.$t("form.address1.plc"),
                                      },
                                      domProps: {
                                        value:
                                          _vm.$v.locationObject.address1.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.locationObject.address1,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("form.address2"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.locationObject.address2) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    { attrs: { for: "form-field-adress2" } },
                                    [_vm._v(_vm._s(_vm.$t("form.address2")))]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.locationObject.address2,
                                        expression: "locationObject.address2",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "form-field-adress2",
                                      name: "address2",
                                      placeholder: _vm.$t("form.address2.plc"),
                                    },
                                    domProps: {
                                      value: _vm.locationObject.address2,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.locationObject,
                                          "address2",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "grid-x grid-margin-x" }, [
                              _c("div", { staticClass: "cell large-6" }, [
                                _vm.isViewMethod
                                  ? _c("div", { staticClass: "form-group" }, [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("form.zipcode"))),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-control form-control--static",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.locationObject.zipcode
                                              ) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group form-group--required form-group--small",
                                        class: {
                                          "form-group--error":
                                            _vm.$v.locationObject.zipcode
                                              .$error,
                                        },
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "form-field-zipcode",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("form.zipcode"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.$v.locationObject.zipcode
                                                  .$model,
                                              expression:
                                                "$v.locationObject.zipcode.$model",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "loading-spinner--input":
                                              _vm.geocodeLoading,
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "form-field-zipcode",
                                            name: "zipcode",
                                            placeholder:
                                              _vm.$t("form.zipcode.plc"),
                                          },
                                          domProps: {
                                            value:
                                              _vm.$v.locationObject.zipcode
                                                .$model,
                                          },
                                          on: {
                                            keyup: _vm.onChangeZipcode,
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.$v.locationObject.zipcode,
                                                "$model",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                _vm._v(" "),
                                _vm.geocodeObject.zipcode.length > 1
                                  ? _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "select",
                                        {
                                          staticClass:
                                            "form-control form-control--select",
                                          attrs: { name: "zipcode_list" },
                                          on: { change: _vm.onSelectZipcode },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("form.zipcode.choose")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.geocodeObject.zipcode,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: item.zipcode,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(item.zipcode) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "cell large-6" }, [
                                _vm.isViewMethod
                                  ? _c("div", { staticClass: "form-group" }, [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("form.city"))),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-control form-control--static",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(_vm.locationObject.city) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group form-group--required form-group--small",
                                        class: {
                                          "form-group--error":
                                            _vm.$v.locationObject.city.$error,
                                        },
                                      },
                                      [
                                        _c(
                                          "label",
                                          { attrs: { for: "form-field-city" } },
                                          [_vm._v(_vm._s(_vm.$t("form.city")))]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.$v.locationObject.city
                                                  .$model,
                                              expression:
                                                "$v.locationObject.city.$model",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "loading-spinner--input":
                                              _vm.geocodeLoading,
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "form-field-city",
                                            name: "city",
                                            placeholder:
                                              _vm.$t("form.city.plc"),
                                          },
                                          domProps: {
                                            value:
                                              _vm.$v.locationObject.city.$model,
                                          },
                                          on: {
                                            keyup: _vm.onChangeCity,
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.$v.locationObject.city,
                                                "$model",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                _vm._v(" "),
                                _vm.geocodeObject.city.length > 1
                                  ? _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "select",
                                        {
                                          staticClass:
                                            "form-control form-control--select",
                                          attrs: { name: "city_list" },
                                          on: { change: _vm.onSelectCity },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("form.city.choose")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.geocodeObject.city,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: item.city,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(item.city) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("customers.country"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$helpers.countries[
                                              _vm.locationObject.country_code
                                            ]
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.locationObject.country_code
                                          .$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "form-field-country" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("customers.country"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-select-country", {
                                      attrs: { id: "form-field-country" },
                                      model: {
                                        value:
                                          _vm.$v.locationObject.country_code
                                            .$model,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.$v.locationObject.country_code,
                                            "$model",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "$v.locationObject.country_code.$model",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("form.email"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.locationObject.email) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.locationObject.email.$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "form-field-email" } },
                                      [_vm._v(_vm._s(_vm.$t("form.email")))]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.$v.locationObject.email.$model,
                                          expression:
                                            "$v.locationObject.email.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "email",
                                        id: "form-field-email",
                                        name: "email",
                                        placeholder: _vm.$t("form.email.plc"),
                                      },
                                      domProps: {
                                        value:
                                          _vm.$v.locationObject.email.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.locationObject.email,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.$store.getters.userIsAdmin
                              ? [
                                  _vm.isViewMethod
                                    ? _c("div", { staticClass: "form-group" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "location.risk.risk_number"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-control form-control--static",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.locationObject.risk
                                                    .risk_number
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group form-group--required",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "form-field-email",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "location.risk.risk_number"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.locationObject.risk
                                                    .risk_number,
                                                expression:
                                                  "locationObject.risk.risk_number",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              id: "form-field-risk-number",
                                              name: "risk-number",
                                              placeholder: "X00000000",
                                            },
                                            domProps: {
                                              value:
                                                _vm.locationObject.risk
                                                  .risk_number,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.locationObject.risk,
                                                  "risk_number",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _vm.locationObject.risk
                                    ? _c("div", { staticClass: "form-group" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "location.risk.decided_budget"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-control form-control--static",
                                            class: {
                                              "u-color--alert":
                                                !_vm.locationObject.risk
                                                  .decided_budget,
                                            },
                                          },
                                          [
                                            _vm.locationObject.risk
                                              .decided_budget
                                              ? [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$helpers.formateCurrency(
                                                          _vm.locationObject
                                                            .risk.decided_budget
                                                        )
                                                      ) +
                                                      "\n                                          "
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "location.risk.decided_budget.not_exist"
                                                        )
                                                      ) +
                                                      "!\n                                          "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.locationObject.risk.valid_from
                                    ? _c("div", { staticClass: "form-group" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("location.risk.valid_from")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-control form-control--static",
                                            class: {
                                              "u-color--alert":
                                                !_vm.locationObject.risk
                                                  .is_valid,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    _vm.locationObject.risk
                                                      .valid_from,
                                                    "DD.MM.YYYY"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.locationObject.risk.valid_until
                                    ? _c("div", { staticClass: "form-group" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "location.risk.valid_until"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-control form-control--static",
                                            class: {
                                              "u-color--alert":
                                                !_vm.locationObject.risk
                                                  .is_valid,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    _vm.locationObject.risk
                                                      .valid_until,
                                                    "DD.MM.YYYY"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }